import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { store } from '@/store/index';
//  获取字典方法 使用示例 getDict('sex').then(res)  或者 async函数下 const res = await getDict('sex')
export var getDict = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(type) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return store.dispatch("dictionary/getDictionary", type);
        case 2:
          return _context.abrupt("return", store.getters["dictionary/getDictionary"][type]);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getDict(_x) {
    return _ref.apply(this, arguments);
  };
}();

// 使用方法
// import { getGameServerMap } from "@/utils/dictionary";
//  获取区服map 使用示例 getGameServerMap().then(res)  或者 async函数下 const res = await getGameServerMap()
export var getGameServerMap = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return store.dispatch("gameServer/getServer");
        case 2:
          return _context2.abrupt("return", store.getters["gameServer/serverMap"]);
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getGameServerMap() {
    return _ref2.apply(this, arguments);
  };
}();

// 使用方法
// import { getGameServerMap } from "@/utils/dictionary";
//  获取区服map 使用示例 getGameServerDetail().then(res)  或者 async函数下 const res = await getGameServerDetail()
export var getGameServerDetail = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return store.dispatch("gameServer/getServer");
        case 2:
          return _context3.abrupt("return", store.getters["gameServer/serverDetail"]);
        case 3:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getGameServerDetail() {
    return _ref3.apply(this, arguments);
  };
}();
export var getPayMap = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return store.dispatch("itemPay/getPay");
        case 2:
          return _context4.abrupt("return", store.getters["itemPay/payMap"]);
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getPayMap() {
    return _ref4.apply(this, arguments);
  };
}();
export var getPayRmbMap = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return store.dispatch("itemPay/getPay");
        case 2:
          return _context5.abrupt("return", store.getters["itemPay/payRmbMap"]);
        case 3:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function getPayRmbMap() {
    return _ref5.apply(this, arguments);
  };
}();
export var getPartnerMap = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return store.dispatch("gamePartner/getPartner");
        case 2:
          return _context6.abrupt("return", store.getters["gamePartner/partnerMap"]);
        case 3:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function getPartnerMap() {
    return _ref6.apply(this, arguments);
  };
}();
export var getTaskMap = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return store.dispatch("gameTask/getTask");
        case 2:
          return _context7.abrupt("return", store.getters["gameTask/taskMap"]);
        case 3:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function getTaskMap() {
    return _ref7.apply(this, arguments);
  };
}();
export var getSceneMap = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return store.dispatch("gameScene/getScene");
        case 2:
          return _context8.abrupt("return", store.getters["gameScene/sceneMap"]);
        case 3:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function getSceneMap() {
    return _ref8.apply(this, arguments);
  };
}();
export var getXingxingMap = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return store.dispatch("gameXingxing/getXingxing");
        case 2:
          return _context9.abrupt("return", store.getters["gameXingxing/xingxingMap"]);
        case 3:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function getXingxingMap() {
    return _ref9.apply(this, arguments);
  };
}();
export var getReasonMap = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return store.dispatch("reasonMsg/getReason");
        case 2:
          return _context10.abrupt("return", store.getters["reasonMsg/reasonMap"]);
        case 3:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return function getReasonMap() {
    return _ref10.apply(this, arguments);
  };
}();
export var getGameGoodsMap = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return store.dispatch("gameGoods/getGoods");
        case 2:
          return _context11.abrupt("return", store.getters["gameGoods/goodsMap"]);
        case 3:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return function getGameGoodsMap() {
    return _ref11.apply(this, arguments);
  };
}();
export var getGameGoodsQualityMap = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return store.dispatch("gameGoods/getGoods");
        case 2:
          return _context12.abrupt("return", store.getters["gameGoods/goodsQualityMap"]);
        case 3:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return function getGameGoodsQualityMap() {
    return _ref12.apply(this, arguments);
  };
}();
export var getUserInfoMap = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return store.dispatch("userInfo/getUserInfoMap");
        case 2:
          return _context13.abrupt("return", store.getters["userInfo/getUserInfoMap"]);
        case 3:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return function getUserInfoMap() {
    return _ref13.apply(this, arguments);
  };
}();
export var getAuthorityMap = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
    return _regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return store.dispatch("authority/getAuthorityMap");
        case 2:
          return _context14.abrupt("return", store.getters["authority/getAuthorityMap"]);
        case 3:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return function getAuthorityMap() {
    return _ref14.apply(this, arguments);
  };
}();
export var getUserMap = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
    return _regeneratorRuntime().wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return store.dispatch("user/getUserMap");
        case 2:
          return _context15.abrupt("return", store.getters["user/getUserMap"]);
        case 3:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return function getUserMap() {
    return _ref15.apply(this, arguments);
  };
}();
export var getGameCoinMap = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
    return _regeneratorRuntime().wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return store.dispatch("gameCoin/getCoin");
        case 2:
          return _context16.abrupt("return", store.getters["gameCoin/coinMap"]);
        case 3:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return function getGameCoinMap() {
    return _ref16.apply(this, arguments);
  };
}();
export var getChannelMap = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
    return _regeneratorRuntime().wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return store.dispatch("gameChannel/getChannel");
        case 2:
          return _context17.abrupt("return", store.getters["gameChannel/channelMap"]);
        case 3:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return function getChannelMap() {
    return _ref17.apply(this, arguments);
  };
}();
export var getCouponMap = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
    return _regeneratorRuntime().wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return store.dispatch("coupon/getCoupons");
        case 2:
          return _context18.abrupt("return", store.getters["coupon/couponMap"]);
        case 3:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return function getCouponMap() {
    return _ref18.apply(this, arguments);
  };
}();
export var getEventMap = /*#__PURE__*/function () {
  var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
    return _regeneratorRuntime().wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return store.dispatch("gameEvent/getEvent");
        case 2:
          return _context19.abrupt("return", store.getters["gameEvent/eventMap"]);
        case 3:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  return function getEventMap() {
    return _ref19.apply(this, arguments);
  };
}();
export var getAdPositionMap = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
    return _regeneratorRuntime().wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return store.dispatch("adPosition/getAdPosition");
        case 2:
          return _context20.abrupt("return", store.getters["adPosition/adPositionMap"]);
        case 3:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
  return function getAdPositionMap() {
    return _ref20.apply(this, arguments);
  };
}();
export var getGameplayTypeMap = /*#__PURE__*/function () {
  var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
    return _regeneratorRuntime().wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return store.dispatch("gameplayType/getGameplayType");
        case 2:
          return _context21.abrupt("return", store.getters["gameplayType/gameplayTypeMap"]);
        case 3:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return function getGameplayTypeMap() {
    return _ref21.apply(this, arguments);
  };
}();